const LeftMenuConfig = [
    // {
    //     "alias": "成本",
    //     "name": "成本",
    //     "link": "/incontrast",
    //     "index": "/pages/incontrast/app",
    //     "icon": "iconziyuan14",
    //     "path": "/incontrast",
    //     "children": [{
    //         "alias": "成本",
    //         "name": "成本",
    //         "link": "/incontrast1",
    //         "index": "/pages/incontrast1/app",
    //         "path": "/incontrast1"
    //     }]
    // },
    
];

// 深复制一个配置用于传递修改；
let [...dynamicLeftMenuConfig] = LeftMenuConfig;

export default dynamicLeftMenuConfig;


// WEBPACK FOOTER //
// ./src/config/left-menu-config.js